import { Box } from "../components";
import React from "react";
export const MapTooltip = React.forwardRef(({ tooltipId, disableArrow = false, disableDisplayCondition = false, children, }, ref) => {
    return (React.createElement(Box, { ref: ref, id: tooltipId, sx: {
            position: "relative",
            width: "fit-content",
            cursor: "default",
            display: !disableDisplayCondition ? "none" : undefined,
            background: (theme) => theme.palette.background.main,
            color: (theme) => theme.palette.background.onMain,
            boxShadow: (theme) => theme.shadows.sm,
            borderRadius: (theme) => theme.radius.default,
            border: 1,
            borderColor: (theme) => theme.palette.stroke[100],
            "&::after": !disableArrow
                ? {
                    content: '""',
                    position: "absolute",
                    bottom: "-12px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 0,
                    height: 0,
                    borderLeft: "12px solid transparent",
                    borderRight: "12px solid transparent",
                    borderTop: (theme) => `12px solid ${theme.palette.background.main}`,
                }
                : undefined,
            /**
             * Fixes the marker offset positioning issue
             * https://github.com/mapbox/mapbox-gl-js/issues/10749#issuecomment-1739940929
             */
            "&.mapboxgl-marker": {
                position: "absolute",
                top: 0,
                left: 0,
                willChange: "transform",
                opacity: 1,
                transition: "opacity .2s",
            },
        } }, children));
});
//# sourceMappingURL=MapTooltip.js.map